/*
 * CELEBRATEVITAMINS CUSTOM — savings calculator for sections/cv-subscription-explainer.liquid.
 * Category chips → product picker with images → option chips (flavour, size, …) → delivery
 * frequency → plan (flexible / 12 months) → quantity → live prices, savings per year, add to cart.
 * All prices come from the selling plans printed by the section (market currency).
 */
(function () {
  'use strict';

  var KEYS = ['m1_flex', 'm3_flex', 'm1_commit', 'm3_commit'];

  function formatMoney(cents, format) {
    var re = /\{\{\s*(\w+)\s*\}\}/;
    format = format || '€{{amount_with_comma_separator}}';
    var m = format.match(re);
    function delim(n, p, t, d) {
      var parts = (n / 100).toFixed(p).split('.');
      return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + t) + (parts[1] ? d + parts[1] : '');
    }
    var v;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = delim(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = delim(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = delim(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': v = delim(cents, 2, ' ', '.'); break;
      default: v = delim(cents, 2, ',', '.');
    }
    return format.replace(re, v);
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function hasPlan(v) {
    return KEYS.some(function (k) { return v.p[k]; });
  }

  function Calc(root) {
    var dataEl = root.querySelector('[data-cvx-data]');
    if (!dataEl) return;
    try { this.d = JSON.parse(dataEl.textContent); } catch (e) { return; }
    this.root = root;
    this.money = (window.theme && window.theme.moneyFormat) || this.d.moneyFormat;
    this.products = (this.d.products || []).filter(function (p) { return p.v.some(hasPlan); });
    if (!this.products.length) return;

    var byHandle = {};
    this.products.forEach(function (p) { byHandle[p.h] = p; });
    this.cats = [{ label: this.d.all, items: this.products }].concat(
      (this.d.categories || []).map(function (c) {
        return { label: c.label, items: c.handles.map(function (h) { return byHandle[h]; }).filter(Boolean) };
      }).filter(function (c) { return c.items.length; })
    );

    this.q = function (s) { return root.querySelector(s); };
    this.ui = {
      cats: this.q('[data-cvx-cats]'),
      pickBtn: this.q('[data-cvx-pick-btn]'),
      pickImg: this.q('[data-cvx-pick-img]'),
      pickTitle: this.q('[data-cvx-pick-title]'),
      list: this.q('[data-cvx-pick-list]'),
      opts: this.q('[data-cvx-opts]'),
      freqs: Array.prototype.slice.call(root.querySelectorAll('[data-cvx-freq]')),
      terms: Array.prototype.slice.call(root.querySelectorAll('[data-cvx-term]')),
      img: this.q('[data-cvx-img]'),
      result: this.q('[data-cvx-result]'),
      empty: this.q('[data-cvx-empty]'),
      one: this.q('[data-cvx-onetime]'),
      sub: this.q('[data-cvx-sub]'),
      pct: this.q('[data-cvx-pct]'),
      year: this.q('[data-cvx-year]'),
      oneEach: this.q('[data-cvx-onetime-each]'),
      subEach: this.q('[data-cvx-sub-each]'),
      add: this.q('[data-cvx-add]'),
      link: this.q('[data-cvx-link]')
    };
    this.state = { cat: 0, product: this.products[0], sel: [], freq: 'm1', term: 'flex', qty: 1 };
    this.maxQty = 99;

    this.bind();
    this.renderCats();
    this.setProduct(this.products[0]);
  }

  /* ---- Categories ---------------------------------------------------- */

  Calc.prototype.renderCats = function () {
    var self = this;
    var wrap = this.ui.cats;
    wrap.innerHTML = '';
    wrap.hidden = this.cats.length < 2;
    this.cats.forEach(function (c, i) {
      var b = el('button', 'cvx__chip', c.label);
      b.type = 'button';
      b.setAttribute('aria-pressed', i === self.state.cat ? 'true' : 'false');
      b.addEventListener('click', function () {
        self.state.cat = i;
        self.renderCats();
        var items = c.items;
        if (items.indexOf(self.state.product) === -1) self.setProduct(items[0]);
        self.renderList();
      });
      wrap.appendChild(b);
    });
  };

  /* ---- Product picker (listbox with images) ---------------------------- */

  Calc.prototype.renderList = function () {
    var self = this;
    var list = this.ui.list;
    list.innerHTML = '';
    this.cats[this.state.cat].items.forEach(function (p) {
      var li = el('li', 'cvx__pick-opt');
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', p === self.state.product ? 'true' : 'false');
      li.tabIndex = -1;
      if (p.img) {
        var img = el('img', 'cvx__thumb');
        img.src = p.img; img.alt = ''; img.width = 48; img.height = 48; img.loading = 'lazy';
        li.appendChild(img);
      } else {
        li.appendChild(el('span', 'cvx__thumb cvx__thumb--empty'));
      }
      li.appendChild(el('span', 'cvx__pick-name', p.t));
      li.addEventListener('click', function () { self.choose(p); });
      li.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self.choose(p); }
      });
      li.__product = p;
      list.appendChild(li);
    });
  };

  Calc.prototype.open = function (open) {
    this.ui.list.hidden = !open;
    this.ui.pickBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var sel = this.ui.list.querySelector('[aria-selected="true"]') || this.ui.list.firstChild;
      if (sel) { sel.focus(); sel.scrollIntoView({ block: 'nearest' }); }
    }
  };

  Calc.prototype.choose = function (p) {
    this.setProduct(p);
    this.open(false);
    this.ui.pickBtn.focus();
  };

  /* ---- Options (flavour, size, …) -------------------------------------- */

  Calc.prototype.setProduct = function (p) {
    if (!p) return;
    this.state.product = p;
    // Start with the first variant that has a plan.
    var v = p.v.filter(hasPlan)[0] || p.v[0];
    this.state.sel = v.o.slice();
    this.state.qty = 1;
    this.ui.pickTitle.textContent = p.t;
    if (p.img) { this.ui.pickImg.src = p.img; this.ui.pickImg.hidden = false; } else { this.ui.pickImg.hidden = true; }
    this.renderList();
    this.renderOpts();
    this.autoFrequency();
    this.render();
  };

  Calc.prototype.variant = function () {
    var sel = this.state.sel;
    return this.state.product.v.filter(function (v) {
      return v.o.every(function (o, i) { return o === sel[i]; });
    })[0] || null;
  };

  Calc.prototype.renderOpts = function () {
    var self = this;
    var p = this.state.product;
    var wrap = this.ui.opts;
    var fields = [];
    wrap.innerHTML = '';
    p.opts.forEach(function (name, i) {
      var values = [];
      p.v.forEach(function (v) { if (values.indexOf(v.o[i]) === -1) values.push(v.o[i]); });
      if (values.length < 2) return;
      var field = el('div', 'cvx__field');
      field.setAttribute('role', 'group');
      field.setAttribute('aria-label', name);
      field.appendChild(el('span', null, name));
      var chips = el('div', 'cvx__chips');
      values.forEach(function (val) {
        var b = el('button', 'cvx__chip cvx__chip--opt', val);
        b.type = 'button';
        b.setAttribute('aria-pressed', self.state.sel[i] === val ? 'true' : 'false');
        b.addEventListener('click', function () {
          self.state.sel[i] = val;
          // If the exact combination doesn't exist, take the closest variant with this value.
          if (!self.variant()) {
            var match = p.v.filter(function (v) { return v.o[i] === val; })[0];
            if (match) self.state.sel = match.o.slice();
          }
          self.renderOpts();
          self.autoFrequency();
          self.render();
        });
        chips.appendChild(b);
      });
      field.appendChild(chips);
      fields.push(field);
    });

    // Quantity sits on the same row as the last option (usually the size).
    var row = el('div', 'cvx__opt-row');
    var last = fields.pop();
    if (last) row.appendChild(last);
    row.appendChild(this.qtyField());
    fields.push(row);
    fields.forEach(function (f) { wrap.appendChild(f); });
  };

  /* ---- Quantity -------------------------------------------------------- */

  Calc.prototype.qtyField = function () {
    var self = this;
    var d = this.d;
    var id = 'cvx-qty-' + Math.random().toString(36).slice(2, 8);
    var field = el('div', 'cvx__field cvx__qty-field');
    var label = el('label', null, d.qty || 'Quantity');
    label.htmlFor = id;
    field.appendChild(label);

    var box = el('div', 'cvx__qty');
    var minus = el('button', 'cvx__qty-btn', '−');
    minus.type = 'button';
    minus.setAttribute('aria-label', d.qtyMinus || 'Decrease quantity');
    var input = el('input', 'cvx__qty-input');
    input.type = 'number';
    input.id = id;
    input.min = '1';
    input.max = String(this.maxQty);
    input.step = '1';
    input.inputMode = 'numeric';
    input.value = String(this.state.qty);
    var plus = el('button', 'cvx__qty-btn', '+');
    plus.type = 'button';
    plus.setAttribute('aria-label', d.qtyPlus || 'Increase quantity');

    function set(n) {
      n = parseInt(n, 10);
      if (isNaN(n) || n < 1) n = 1;
      if (n > self.maxQty) n = self.maxQty;
      self.state.qty = n;
      input.value = String(n);
      minus.disabled = n <= 1;
      plus.disabled = n >= self.maxQty;
      self.render();
    }
    minus.addEventListener('click', function () { set(self.state.qty - 1); });
    plus.addEventListener('click', function () { set(self.state.qty + 1); });
    input.addEventListener('change', function () { set(input.value); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); set(input.value); }
    });
    minus.disabled = this.state.qty <= 1;

    box.appendChild(minus);
    box.appendChild(input);
    box.appendChild(plus);
    field.appendChild(box);
    return field;
  };

  // After a product/variant change: if the chosen frequency has no plan at all, switch to one that has.
  Calc.prototype.autoFrequency = function () {
    var v = this.variant();
    if (!v) return;
    var has = function (f) { return v.p[f + '_flex'] || v.p[f + '_commit']; };
    if (!has(this.state.freq)) {
      var other = this.state.freq === 'm1' ? 'm3' : 'm1';
      if (has(other)) this.state.freq = other;
    }
    if (!v.p[this.state.freq + '_' + this.state.term] && v.p[this.state.freq + '_flex']) this.state.term = 'flex';
  };

  /* ---- Result ---------------------------------------------------------- */

  Calc.prototype.render = function () {
    var s = this.state;
    var v = this.variant();
    var p = s.product;
    var plan = v ? v.p[s.freq + '_' + s.term] : null;

    this.ui.freqs.forEach(function (b) {
      var f = b.getAttribute('data-cvx-freq');
      b.setAttribute('aria-pressed', f === s.freq ? 'true' : 'false');
      b.classList.toggle('is-unavailable', !(v && (v.p[f + '_flex'] || v.p[f + '_commit'])));
    });
    this.ui.terms.forEach(function (b) {
      var t = b.getAttribute('data-cvx-term');
      b.setAttribute('aria-pressed', t === s.term ? 'true' : 'false');
      b.classList.toggle('is-unavailable', !(v && v.p[s.freq + '_' + t]));
    });

    var img = (v && v.img) || p.img;
    if (img) { this.ui.img.src = img; this.ui.img.hidden = false; } else { this.ui.img.hidden = true; }
    if (this.ui.link) this.ui.link.href = p.u + (p.u.indexOf('?') > -1 ? '&' : '?') + (v ? 'variant=' + v.id : '');

    this.ui.result.hidden = !plan;
    this.ui.empty.hidden = !!plan;

    var add = this.ui.add;
    if (!add.classList.contains('is-busy')) {
      add.disabled = !plan || !v.a;
      add.textContent = v && !v.a ? add.getAttribute('data-l-soldout') : add.getAttribute('data-l-add');
    }
    if (!plan) return;

    var perYear = s.freq === 'm1' ? 12 : 4;
    var qty = s.qty || 1;
    var self = this;
    this.ui.one.textContent = formatMoney(v.c * qty, this.money);
    this.ui.sub.textContent = formatMoney(plan.c * qty, this.money);
    this.ui.pct.textContent = (this.d.pct || '-__V__%').replace('__V__', plan.pct);
    this.ui.year.textContent = formatMoney((v.c - plan.c) * perYear * qty, this.money);
    // "2 × €17,98" under the totals when more than one is chosen.
    var each = function (node, cents) {
      if (!node) return;
      node.hidden = qty < 2;
      node.textContent = qty < 2 ? '' : (self.d.each || '__Q__ × __P__').replace('__Q__', qty).replace('__P__', formatMoney(cents, self.money));
    };
    each(this.ui.oneEach, v.c);
    each(this.ui.subEach, plan.c);
  };

  /* ---- Add to cart ----------------------------------------------------- */

  Calc.prototype.addToCart = function () {
    var self = this;
    var v = this.variant();
    var plan = v && v.p[this.state.freq + '_' + this.state.term];
    var add = this.ui.add;
    if (!plan || !v.a || add.classList.contains('is-busy')) return;

    add.classList.add('is-busy');
    add.disabled = true;
    add.textContent = add.getAttribute('data-l-adding');

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: self.state.qty || 1, selling_plan: plan.id }] })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || (data && typeof data.status === 'number' && data.status >= 400)) throw new Error((data && data.description) || 'add_error');
        return data;
      });
    }).then(function (data) {
      add.textContent = add.getAttribute('data-l-added');
      try { document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { detail: { item: data } })); } catch (e) { /* noop */ }
      setTimeout(function () {
        if (document.body.getAttribute('data-fluorescent-overlay-open') === 'true') return;
        var icon = Array.prototype.filter.call(document.querySelectorAll('[data-js-cart-icon]'), function (n) {
          return n.offsetParent !== null;
        })[0] || document.querySelector('[data-js-cart-icon]');
        if (icon) icon.click();
      }, 300);
      if (window.dataLayer) {
        window.dataLayer.push({ event: 'subscription_calculator_add', variant_id: v.id, quantity: self.state.qty || 1, selling_plan_id: plan.id, frequency: self.state.freq, commitment: self.state.term });
      }
    }).catch(function () {
      add.textContent = add.getAttribute('data-l-error');
    }).then(function () {
      setTimeout(function () {
        add.classList.remove('is-busy');
        self.render();
      }, 2000);
    });
  };

  /* ---- Events ---------------------------------------------------------- */

  Calc.prototype.bind = function () {
    var self = this;
    var ui = this.ui;

    ui.pickBtn.addEventListener('click', function () { self.open(ui.list.hidden); });
    ui.pickBtn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); self.open(true); }
    });
    ui.list.addEventListener('keydown', function (e) {
      var items = Array.prototype.slice.call(ui.list.children);
      var i = items.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[0]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); (items[i - 1] || items[items.length - 1]).focus(); }
      else if (e.key === 'Home') { e.preventDefault(); items[0].focus(); }
      else if (e.key === 'End') { e.preventDefault(); items[items.length - 1].focus(); }
      else if (e.key === 'Escape') { e.preventDefault(); self.open(false); ui.pickBtn.focus(); }
      else if (e.key === 'Tab') { self.open(false); }
    });
    document.addEventListener('click', function (e) {
      if (!ui.list.hidden && !self.q('[data-cvx-picker]').contains(e.target)) self.open(false);
    });

    ui.freqs.forEach(function (b) {
      b.addEventListener('click', function () { self.state.freq = b.getAttribute('data-cvx-freq'); self.render(); });
    });
    ui.terms.forEach(function (b) {
      b.addEventListener('click', function () { self.state.term = b.getAttribute('data-cvx-term'); self.render(); });
    });
    ui.add.addEventListener('click', function () { self.addToCart(); });
  };

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cvx-calc]'), function (root) {
      if (root.__cvx) return;
      root.__cvx = true;
      new Calc(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Theme editor: re-init when the section is re-rendered.
  document.addEventListener('shopify:section:load', init);
})();
